import { useMutation, useQueryClient } from 'react-query';
import { PAYMENT_QUERY_KEY } from './usePaymentQuery';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

const savePayment = ({ clientId, data }) => {
  return authFetch('/Consumer/BluePay/StorePaymentInformation', {
    method: 'POST',
    ...httpBodyOptions({ clientId, ...data }),
  });
};

export const useSavePaymentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(savePayment, {
    onSuccess(_, { clientId }) {
      queryClient.invalidateQueries([PAYMENT_QUERY_KEY, clientId]);
    },
  });
};
